module.exports = __webpack_public_path__ + "static/s3-intro-d-5af6ad750e2086a9de1b2a5dde3a42b2.jpg";